import { useContext } from "react";
import { ContextProfileUser } from "../../lib/profileContext";
import cn from "classnames";
import { domains } from "../../constants";

const CustomEmailAutoComplete = ({ errorEmail, errorCb }) => {
  const { data, setData } = useContext(ContextProfileUser);

  const setFullEmail = (fullEmail) => {
    errorCb();
    setData((prevData) => ({ ...prevData, email: fullEmail }));
  };

  if (!data?.email || data.email.includes("@")) {
    return null;
  }

  return (
    <div className={cn("autocomplete__box", { error: errorEmail })}>
      <ul className="autocomplete__box-list">
        {domains.map((domain, index) => (
          <li
            onClick={() => setFullEmail(data.email + domain)}
            className="autocomplete__box-list-item"
            key={index}
          >
            {data.email}
            {domain}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomEmailAutoComplete;
